import {
  deleteRecord,
  getRecord,
  listRecords,
  saveRecord,
} from '@/services/localDb';

export async function saveHubProfile(profile) {
  if (!profile?.hub_uuid) return null;
  return saveRecord('hub_profiles', {
    ...profile,
    updated_at: new Date().toISOString(),
  });
}

export async function getHubProfile(hubUuid) {
  if (hubUuid) return getRecord('hub_profiles', hubUuid);
  const profiles = await listRecords('hub_profiles');
  return profiles.sort((a, b) => (
    String(b.updated_at || '').localeCompare(String(a.updated_at || ''))
  ))[0] || null;
}

export async function saveLocalHubCredential(credential) {
  if (!credential?.hub_uuid || !credential?.local_device_secret) return null;
  return saveRecord('local_hub_credentials', {
    ...credential,
    updated_at: new Date().toISOString(),
  });
}

export async function getLocalHubCredential(hubUuid) {
  if (!hubUuid) return null;
  return getRecord('local_hub_credentials', hubUuid);
}

export async function deleteLocalHubCredential(hubUuid) {
  if (!hubUuid) return false;
  return deleteRecord('local_hub_credentials', hubUuid);
}
